<script setup>
import SectionHero from '@/components/SectionHero.vue';

import {useRouting} from "@/composables/routing.js";
const {href,url} = useRouting();

import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Head>
        <title>The cloud for web applications</title>
        <meta name="description" content="The LAY7 Cloud is the managed cloud solution for web applications, ideal for websites, online stores, and backend applications.">
        <link rel="canonical" :href="url('/', 'en')">
        <link rel="alternate" hreflang="de" :href="url('/', 'de')">
        <link rel="alternate" hreflang="en" :href="url('/', 'en')">
    </Head>
    <div>
        <section-hero title="The cloud for web applications"
                      subtitle="Simple operation and a high level of security. Perfect for websites, stores and backend applications. Particularly affordable due to sharing of resources such as load balancers"
        >
            <div class="mb-8 lg:mb-16 flex justify-center space-y-0 space-x-4">
                <Link :href="href('/features')"
                      class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white bg-primary hover:bg-primary-800 focus:ring-4 focus:ring-primary-300"
                >
                    {{ $t("Features") }}
                    <i class="pi pi-arrow-right ml-3"></i>
                </Link>

                <Link :href="href('/pricing')"
                      class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100"
                >
                    <i class="pi pi-euro mr-3"></i>
                    {{ $t("Pricing") }}
                </Link>
            </div>
        </section-hero>

        <section class="mt-10">
            <div class="container px-4 mx-auto flex justify-center">
                <img src="/assets/dashboard.png"
                     alt="LAY7 cloud dashboard"
                     class="rounded-xl shadow-2xl w-full max-w-[900px]">
            </div>
        </section>

        <section class="mt-32 lg:mt-48">
            <div class="container px-4 mx-auto">
                <h2 class="font-semibold text-4xl text-black space-x-3 mb-5">
                    Further development of the webspace
                </h2>

                <p class="text-xl">
                    If the world of major cloud providers seemed too complicated for you (and it is),
                    you’ve probably relied on the good old web hosting. That’s now a thing of the past.
                    Introducing the LAY7 cloud. The setup is as simple as web hosting, but the possibilities
                    are exponentially greater. And best of all, the LAY7 cloud is just as affordable as
                    traditional web hosting.
                </p>

                <div class="container mx-auto mt-10">
                    <div class="flex flex-col md:flex-row gap-5">
                        <div class="flex-1 rounded-xl p-6 flex flex-col border border-primary-300">
                            <h2 class="text-xl font-bold mb-2">Spaces</h2>
                            <p class="text-gray-700">
                                Spaces are our advanced version of web hosting. They are easy to configure and
                                come with guaranteed resources (RAM, CPU), ensuring that the performance
                                you've booked is always available to you.
                            </p>
                        </div>

                        <div class="flex-1 rounded-lg  p-6 flex flex-col border border-primary-300">
                            <h2 class="text-xl font-bold mb-2">Databases</h2>
                            <p class="text-gray-700">
                                Databases are a crucial component of many web applications. In the LAY7 cloud,
                                you can create and manage MySQL databases quickly and easily. Like our Spaces,
                                they are simple to configure and come with guaranteed resources.
                            </p>
                        </div>

                        <div class="flex-1 rounded-lg p-6 flex flex-col border border-primary-300">
                            <h2 class="text-xl font-bold mb-2">Routes</h2>
                            <p class="text-gray-700">
                                Routes define how your application can be accessed externally. They can be
                                configured both by domain and by path. Routes run on our highly available
                                load balancers, and a free SSL certificate is included.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="mt-32 lg:mt-48">
            <div class="container px-4 mx-auto">
                <div class="flex text-center font-semibold text-4xl text-black justify-center items-center">
                    The 🖤 of the LAY7 cloud
                </div>

                <p class="text-xl mt-5 text-center">
                    The LAY7 Cloud is built on a Kubernetes cluster, which has become one of the most important
                    technologies for the distributed deployment of applications. However, Kubernetes can be quite
                    complex to use. We’ve designed the LAY7 Cloud so you can enjoy the benefits of Kubernetes without
                    needing to dive into its intricate details.
                </p>
            </div>
        </section>
    </div>
</template>
